import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Champ mot de passe réutilisable avec bascule afficher/masquer (œil). Ne modifie jamais la valeur, uniquement son affichage.
export const PasswordInput = ({ className = "", iconClassName = "", testId, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={visible ? "text" : "password"} data-testid={testId} className={`${className} pr-11`} />
      <button
        type="button"
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle-visibility` : undefined}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        className={`absolute right-3.5 top-1/2 -translate-y-1/2 opacity-50 transition-opacity hover:opacity-100 ${iconClassName}`}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
